import React from 'react';
import MetaTags from './MetaTags';
import AppBar from './AppBar'
import { Container,Row,Col } from 'react-bootstrap'
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail } from "react-icons/md";
import Mark from './Mark';
const ContactUs = () => {
  return (
    <div>
       <MetaTags
        title="Contact Us - RM Crackers - Whole sale Crackers"
        type="website"
        siteName="rmcrackers.com"
        url="https://zencrackersdemo.zentexus.com/contactus"
        keywords="Contact Us | RM Crackers "
        description="Contact for wholesale Crackers and Retail Crackers"
        revisitAfter="10 Days"
      />
      <AppBar/>
      <img src={require('../assets/images/b3.jpg')} className='img-fluid w-100' alt='product name' />
        <Container className='padding'>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} className='py-3'>
                <div className='bold  text-center'> Contact Us</div>
              </Col>
              <Col lg="4">
                <div className='box'>
                    <div className='box-icon'>
                      <PiMapPinSimpleAreaBold size={40} color={'#fff'} />
                    </div>
                    <div className='regular'>
                         Virudhunagar, Tamil Nadu, India
                    </div>
                </div>
              </Col>
              <Col lg="4">
                <div className='box'>
                    <div className='box-icon'>
                    <BiPhoneCall size={40} color={'#fff'}/>
                    </div>
                    <div>
                    <div>+91 90251 48394</div>
                    <div>+91 87545 51707</div>
                    </div>
                </div>
              </Col>
              <Col lg="4">
                <div className='box'>
                    <div className='box-icon'>
                       <MdOutlineAlternateEmail size={40} color={'#fff'}/>
                    </div>
                    <div className='pb-4'>
                       <div>office.zentexus@gmail.com</div> 
                    </div>
                </div>
              </Col>
            </Row>
        </Container>
        <>
        
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3935.8046337571022!2d77.81590747502392!3d9.438525490640052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOcKwMjYnMTguNyJOIDc3wrA0OScwNi41IkU!5e0!3m2!1sen!2sin!4v1724242146306!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          title="Google Maps Embed of Sivakasi, Tamil Nadu"
        />
        </>
      
        <>
        <Mark/>
        </>
    </div>
  )
}

export default ContactUs